import React from "react";
import { Link } from "gatsby";

// Styles //
import "./radio-filter-enctal.scss";

// Utils //
import { validPathname } from "../../../utils/helpers";

interface RadioFilterProps {
    id: string;
    label: string;
    name: string;
    value?: any;
    handleChange?: (e: any) => void;
}

const RadioFilterEnctal = (props: RadioFilterProps) => {
    const {
        id,
        label,
        name,
        value,
        handleChange
    } = props;

    return (
        <>
            <div className="wrapper-filter-enctal">
                <div className="radio-filter-enctal">
                    <input
                        type="radio"
                        name={name}
                        id={id}
                        value={value}
                        data-label={label}
                        onChange={(e) => handleChange!(e)}
                    />
                    <label htmlFor={id}>
                        {label}
                    </label>
                </div>
            </div>
        </>
    );
};

export default RadioFilterEnctal;
